import { call, put, takeEvery } from 'redux-saga/effects'

import { types } from '../../types'
import {
  addTeamMember,
  getTeamMember,
  removeTeamMember,
  updateTeamMember,
} from '../apiRequests/teamMemberRequest'

function* handleGetTeamMembers(action) {
  try {

    const response = yield call(getTeamMember, action.params)

    yield put({
      type: types.GET_TEAM_PANEL_MEMBERS_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_TEAM_PANEL_MEMBERS_ERROR,
      error: error.response,
    })
  }
}
function* handleAddTeamMembers(action) {
  try {
    const user = JSON.parse(localStorage.getItem('sipOnlineUser'))
    const response = yield call(
      addTeamMember,
      action.params,
      action.id ? action.id : user.userId,
      action.webAddress,
    )

    yield put({
      type: types.ADD_MEMBER_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.ADD_MEMBER_ERROR,
      error: error.response,
    })
  }
}

function* handleRemoveTeamMembers(action) {
  try {
    const response = yield call(removeTeamMember, action.params)
    yield put({
      type: types.DELETE_MEMBER_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.DELETE_MEMBER_ERROR,
      error: error.response,
    })
  }
}
function* handleUpdateTeamMembers(action) {
  try {
    const response = yield call(updateTeamMember, action.params, action.id, action.webAddress)

    yield put({
      type: types.UPDATE_MEMBER_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.UPDATE_MEMBER_ERROR,
      error: error.response,
    })
  }
}

function* watcherTeamMembersSaga() {
  yield takeEvery(types.GET_TEAM_PANEL_MEMBERS_REQUEST, handleGetTeamMembers)
  yield takeEvery(types.ADD_MEMBER_REQUEST, handleAddTeamMembers)
  yield takeEvery(types.DELETE_MEMBER_REQUEST, handleRemoveTeamMembers)
  yield takeEvery(types.UPDATE_MEMBER_REQUEST, handleUpdateTeamMembers)
}

export default watcherTeamMembersSaga
